// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButton_root__a_SlM","label":"IconButton_label__l5mb5"};